import React, { Component } from 'react';
import { connect } from 'react-redux';
import { trackMixpanelPageView } from '@helpers/post';
import { withQueryParamCapture } from '@helpers/useQueryParamCapture';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import CostEstimator from './components/CostEstimator/CostEstimator';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Coverage from './components/Coverage/Coverage';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/FAQ/FAQ';
import FooterCTA from './components/FooterCTA/FooterCTA';
import './PricingLanding.scss';

class PricingLanding extends Component {
  componentDidMount() {
    document.title = 'Go4 Pricing — One Flat 17.5% Service Fee';
    trackMixpanelPageView('/pricing');
  }

  goToLogin = () => {
    this.props.history.push('/login');
  };

  goToSignUp = (source = 'unknown') => {
    trackMixpanelPageView('PricingLandingCTAClick', { source });
    this.props.history.push('/create-account/organization-type');
  };

  scrollToEstimator = () => {
    const el = document.getElementById('pricing');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  render() {
    return (
      <div className="pricing-landing">
        <Header onLogin={this.goToLogin} onPostJob={() => this.goToSignUp('header')} />
        <Hero onEstimate={this.scrollToEstimator} onPostJob={() => this.goToSignUp('hero')} />
        <CostEstimator id="pricing" onPostJobClick={() => this.goToSignUp('cost_estimator')} />
        <HowItWorks />
        <Coverage onBackToEstimator={this.scrollToEstimator} />
        <Testimonials />
        <FAQ />
        <FooterCTA onPostJob={() => this.goToSignUp('footer_cta')} onReRun={this.scrollToEstimator} />
      </div>
    );
  }
}

export default withQueryParamCapture(connect()(PricingLanding));
